<template>
  <div style=" margin: 0 auto 20px;min-height: 320px;height: 35vh;overflow-y:auto;">
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        空间：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-cascader
          :options="spaceTree"
          @change="spaceChange"
          change-on-select="true"
          clearable
          collapse-tags
          filterable
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px; width: 80%"
          v-model="spaceId">
        </el-cascader>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        屏蔽类型：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-radio-group @change="typeChange" v-model="type">
          <el-radio label="0" style="margin-top: 7px;">主机屏蔽</el-radio>
          <el-radio label="1" style="margin-top: 7px;">设备屏蔽</el-radio>
          <el-radio label="2" style="margin-top: 7px;">测点屏蔽</el-radio>
        </el-radio-group>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px" v-if="type==0">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        主机：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-select
          :multiple="gatewayMultiple"
          clearable
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 80%"
          v-model="gateway">
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.snCode"
            v-for="item in gatewayList">
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px" v-if="type!=0">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        设备：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-select
          :multiple="deviceMultiple"
          @change="deviceChange"
          clearable
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 80%"
          v-model="device">
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in deviceList">
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px" v-if="type!=0 && type !=1">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        测点：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-select
          :multiple="pointMultiple"
          clearable
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: 80%"
          v-model="point">
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in pointList">
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        是否启用：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-radio label="0" style="margin-top: 7px;" v-model="isShield">否</el-radio>
        <el-radio label="1" style="margin-top: 7px;" v-model="isShield">是</el-radio>
      </el-col>
    </el-col>

    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        屏蔽时间：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <div style="padding-top: 1px">
          <el-checkbox v-model="designatedTime">指定时间</el-checkbox>
        </div>
        <div v-if="designatedTime">
          <div :key="index" v-for="(item,index) in timeList">
            <el-time-picker
              end-placeholder="结束时间"
              format="HH:mm"
              is-range
              placeholder="选择时间范围"
              range-separator="至"
              size="mini"
              start-placeholder="开始时间"
              style="margin-top: 10px;width: 70%"
              v-model="item.value"
              value-format="HH:mm">
            </el-time-picker>
            <el-button @touchstart="addTime" @click="addTime" size="mini" style="color: #07E6F8;margin-left: 5px" v-if="index === 0"> +
            </el-button>
            <el-button @touchstart="deleteTime" @click="deleteTime(index)" size="mini" style="color: red;margin-left: 5px;padding: 7px 17px;"
                       v-else>-
            </el-button>
          </div>
        </div>
      </el-col>
    </el-col>
  </div>
</template>

<script>
import {gatewayList} from "@/network/device-gateway";
import {userDevice} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";
import lodash from "lodash";

export default {
  name: "ShieldModify",
  props: ["spaceTree", "form"],
  data() {
    return {
      spaceId: '',
      isShield: '0',
      gateway: '',
      device: '',
      point: '',
      type: '0',
      spaceInfoId: '',
      popHeight: '30vh',
      gatewayList: [],
      deviceList: [],
      pointList: [],
      gatewayMultiple: true,
      deviceMultiple: false,
      pointMultiple: false,
      designatedTime: true,
      timeList: []
    }
  },
  watch: {
    spaceTree(newVal) {
      this.spaceTree = newVal;
      this.getDeviceList();
    },
    form(newVal) {
      this.form = newVal;
      this.setForm(lodash.cloneDeep(this.form));
    }
  },
  created() {
    this.getGatewayList();
  },
  mounted() {
    this.setForm(this.form);
  },
  methods: {
    addTime() {
      this.timeList.push({
        value: ''
      })
    },
    deleteTime(index) {
      this.timeList.splice(index, 1)
    },
    typeChange(newVal) {
      this.gateway = '';
      this.device = '';
      this.point = '';
      this.checkType(newVal);
    },
    checkType(newVal) {
      if (newVal == 0) {
        this.popHeight = '30vh';
        this.gatewayMultiple = true;
        this.pointMultiple = this.deviceMultiple = false;
      }
      if (newVal == 1) {
        this.popHeight = '30vh';
        this.pointMultiple = this.gatewayMultiple = false;
        this.deviceMultiple = true;
      }
      if (newVal == 2) {
        this.popHeight = '40vh';
        this.deviceMultiple = this.gatewayMultiple = false;
        this.pointMultiple = true;
      }
    },
    spaceChange(val) {
      if (val) {
        if (val.length > 0) {
          // 查询空间  若空间为逻辑空间，不允许选中
          this.spaceInfoId = val[val.length - 1];
          this.getDeviceList();
          this.device = '';
          this.point = '';
        }
      }
    },
    deviceChange() {
      if (this.type == 2) {
        this.getPointList();
        this.point = '';
      }
    },
    getGatewayList() {
      gatewayList().then(res => {
        if (res.data) {
          this.gatewayList = res.data;
        }
      });
    },
    getDeviceList() {
      let spaceInfo = Array.isArray(this.spaceInfoId) ? this.spaceInfoId[0] : this.spaceInfoId;
      if (spaceInfo.length > 0) {
        userDevice(spaceInfo).then(res => {
          if (res.data) {
            this.deviceList = res.data
          }
        })
      }
    },
    getPointList() {
      let device = Array.isArray(this.device) ? this.device[0] : this.device;
      listByDeviceId(device).then(res => {
        if (res.data) {
          this.pointList = res.data
        }
      });
    },
    checkForm() {
      if (!this.spaceId) {
        this.$message.error('请选择空间');
        return false;
      }
      if (this.type == 0 && this.gateway.length <= 0) {
        this.$message.error('请选择主机');
        return false;
      }
      if (this.type > 0 && this.device.length <= 0) {
        this.$message.error('请选择设备');
        return false;
      } else if (this.type > 1 && this.point.length <= 0) {
        this.$message.error('请选择测点');
        return false;
      }
      return true;
    },
    setForm(form) {
      if (form.spaceId !== undefined) {
        this.timeList = []
        if (form.alarmShieldTimeFrames && form.alarmShieldTimeFrames.length > 0) {
          form.alarmShieldTimeFrames.forEach(item => {
            const time = {
              value: [item.startHour + ":" + item.startMinute, item.endHour + ":" + item.endMinute]
            }
            this.timeList.push(time)
          })
        }
        this.spaceInfoId = form.spaceId;
        this.type = form.shieldType + "";
        this.checkType(this.type);
        this.spaceId = form.spaceId;
        this.isShield = form.isEnable ? "1" : "0";
        this.gateway = '';
        this.device = '';
        this.point = '';

        this.gateway = this.type == 0 ? [form.gatewaySn] : form.gatewaySn;
        this.device = this.type == 1 ? [form.deviceId] : form.deviceId;
        this.point = this.type == 2 ? [form.pointId] : form.pointId;
        // 获取设备
        this.getDeviceList();
        // 获取测点
        if (form.shieldType > 1) {
          this.getPointList();
        }
        this.$forceUpdate();
      } else {
        this.getDeviceList();
        this.spaceId = '';
        this.isShield = '0';
        this.device = '';
        this.point = '';
        this.type = '0';
        this.gateway = '';
        this.spaceInfoId = '';
        this.popHeight = '30vh';
        this.deviceList = [];
        this.pointList = [];
        this.gatewayMultiple = false;
        this.deviceMultiple = false;
        this.pointMultiple = false;

        this.timeList = [{
          value: "",
        }]
      }
    },
    getForm() {
      let returnForm = [];
      let alarmShieldTimeFrames = []
      if (this.timeList.length > 0) {
        this.timeList.forEach(item => {
          if (item.value && item.value.length > 0) {
            const data = {}
            data.startTime = item.value[0]
            data.endTime = item.value[1]
            alarmShieldTimeFrames.push(data)
          }
        })
      }
      let spaceId = Array.isArray(this.spaceId) ? this.spaceId[this.spaceId.length - 1] : this.spaceId;
      // 校验数据
      if (this.checkForm()) {
        let isEnbale = this.isShield == 1;
        // 组装数据 返回
        if (this.type == 0) {
          if (Array.isArray(this.gateway)) {
            for (let item of this.gateway) {
              let form = {
                isEnable: isEnbale,
                spaceId: spaceId,
                shieldType: this.type,
                gatewaySn: item,
                alarmShieldTimeFrames: alarmShieldTimeFrames
              }
              returnForm.push(form);
            }
          } else {
            let form = {
              isEnable: isEnbale,
              spaceId: spaceId,
              shieldType: this.type,
              gatewaySn: this.gateway,
              alarmShieldTimeFrames: alarmShieldTimeFrames
            }
            returnForm.push(form);
          }
          return returnForm;
        } else if (this.type == 1) {
          if (Array.isArray(this.device)) {
            for (let item of this.device) {
              let device = this.deviceList.filter(i => i.id == item)[0];
              let form = {
                isEnable: isEnbale,
                spaceId: spaceId,
                shieldType: this.type,
                deviceId: item,
                gatewaySn: device.gatewaySn,
                alarmShieldTimeFrames: alarmShieldTimeFrames
              }
              returnForm.push(form);
            }
          } else {
            let device = this.deviceList.filter(i => i.id == this.device)[0];
            let form = {
              isEnable: isEnbale,
              spaceId: spaceId,
              shieldType: this.type,
              deviceId: this.device,
              gatewaySn: device.gatewaySn,
              alarmShieldTimeFrames: alarmShieldTimeFrames
            }
            returnForm.push(form);
          }
          return returnForm;
        } else if (this.type == 2) {
          let device = this.deviceList.filter(i => i.id == this.device)[0];
          if (Array.isArray(this.point)) {
            for (let item of this.point) {
              let form = {
                isEnable: isEnbale,
                spaceId: spaceId,
                gatewaySn: device.gatewaySn,
                shieldType: this.type,
                deviceId: this.device,
                pointId: item,
                alarmShieldTimeFrames: alarmShieldTimeFrames
              }
              returnForm.push(form);
            }
          } else {
            let form = {
              isEnable: isEnbale,
              spaceId: spaceId,
              gatewaySn: device.gatewaySn,
              shieldType: this.type,
              deviceId: this.device,
              pointId: this.point,
              alarmShieldTimeFrames: alarmShieldTimeFrames
            }
            returnForm.push(form);
          }
          return returnForm;
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
<style>
</style>
